import { Button, CaptionText, HeadingText } from '@paypalcorp/pp-react';
import { Message } from '@paypalcorp/worldready-react';
import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isLoggedIn, isMobileLayout } from '../../helpers/twHelper';
import { CALL_US_INFO, FPTI_DATA } from '../../common/propTypes';
import { generateLinkData, trackActivityEvent } from '../../helpers/analytics/fptiHelper';

function WebPinCard(props) {
  const { callUsInfo, onLoginClick, FPTIData } = props;
  const webPinNo = callUsInfo.webPin;

  useEffect(() => {
    if (webPinNo) {
      trackActivityEvent({
        ...FPTIData.callUsWebPinShown,
        link: generateLinkData(FPTIData.callUsWebPinShown.link, { webPinNo }),
      });
    }
  }, [webPinNo]);

  const handleWebPinCardContentsClasses = () =>
    classNames({
      sh_callUs_webpin_card_contents: !isMobileLayout(),
    });

  const renderWebPin = () => {
    if (webPinNo && isLoggedIn()) {
      return (
        <div className="sh_callUs_web_pin_content">
          <HeadingText size="md" className="sh_callUs_webpin_number" data-testid="sh-callUs-webpin-number">
            {webPinNo}
          </HeadingText>
          <CaptionText
            className="sh_callUs_webpin_logged_out_message"
            data-testid="sh-callUs-webpin-logged-out-message"
          >
            <Message id="smarthelp.app.callUs.Webpin.loggedIn.message" />
          </CaptionText>
        </div>
      );
    }
    if (!isLoggedIn()) {
      return (
        <div className="sh_callUs_web_pin_content">
          <Button
            className="sh_callUs_webpin_login"
            data-testid="sh-callUs-webpin-login"
            onClick={(e) => onLoginClick(e)}
          >
            <Message id="smarthelp.app.callUs.LoggedOut.Button.label" />
          </Button>
          <CaptionText
            className="sh_callUs_webpin_logged_out_message"
            data-testid="sh-callUs-webpin-logged-out-message"
          >
            <Message id="smarthelp.app.callUs.Webpin.loggedOut.message" />
          </CaptionText>
        </div>
      );
    }
    return null;
  };

  const renderWebPinCardImage = () => {
    return (
      <div>
        <img
          src="https://www.paypalobjects.com/Smarthelpnodeweb/shield-with-lock-key.png"
          alt=""
          className="sh_callUs_web_pin_Image"
          data-testid="sh-callUs-web-pin-Image"
        />
      </div>
    );
  };

  const renderWebPinCard = () => {
    return (
      <div className="sh_callUs_webpin_card">
        <div className="sh_callUs_webpin_card_header" data-testid="sh-callUs-webpin-card-header">
          <HeadingText size="md" className="sh_callUs_webpin_header" data-testid="sh-callUs-webpin-header">
            <Message id="smarthelp.app.callUs.Webpin.Header.label" />
          </HeadingText>
        </div>
        <div className={handleWebPinCardContentsClasses()} data-testid="sh-callUs-webpin-card-contents">
          {!isMobileLayout() && renderWebPinCardImage()}
          {renderWebPin()}
        </div>
      </div>
    );
  };

  return <Fragment>{renderWebPinCard()}</Fragment>;
}

WebPinCard.propTypes = {
  FPTIData: PropTypes.shape(FPTI_DATA).isRequired,
  onLoginClick: PropTypes.func.isRequired,
  callUsInfo: PropTypes.shape(CALL_US_INFO).isRequired,
};

export default WebPinCard;
